import { useAppSearchParams } from '@/hooks/useAppSearchParams.ts';
import { TournamentLeaderboard } from '@/pages/LeaderboardPage/TournamentLeaderboard/index.tsx';
import { PickemLeaderboard } from '@/pages/LeaderboardPage/PickemLeaderboard/index.tsx';

// Pickem or Tournament Leaderboard
export default function LeaderboardPage() {
  const { pickemId, leagueId, tournamentId } = useAppSearchParams();

  if (Boolean(pickemId)) {
    return <PickemLeaderboard />;
  }

  if (Boolean(leagueId) || Boolean(tournamentId)) {
    return <TournamentLeaderboard />;
  }

  return null;
}
